import React, { useRef, useState } from "react";
import {
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
} from "@material-ui/core";
import MuiButton from "Components/MuiButton/MuiButton";
import Translator from "Languages/Utility/Translator";
import * as Icons from "react-bootstrap-icons";
import { ReactSVG } from "react-svg";
import Rectangle from "Assets/svg/icon/newRectangle_nv.svg";
import NewUnit from "Assets/svg/icon/newUnit_nv.svg";
import showNotify from "Helpers/Notify";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

export default function NewUnitButtonManager({ loading, onAction }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const { userData, unitListPagination } = useSelector((state) => ({
    userData: state.auth.userData,
    unitListPagination: state.design.unitListPagination,
  }));
  const anchorRef = useRef(null);

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const handleToggleMenu = () => {
    if (
      userData?.panel &&
      userData?.panel?.isFree &&
      unitListPagination.Total >= userData?.panel?.maxUnit
    ) {
      showNotify({
        text: t("freeAccountLimit"),
        customClass: "error",
      });
      return;
    } else {
      setOpen(!open);
    }
  };

  const onClick = (value) => {
    onAction(value);
  };

  return (
    <>
      <MuiButton
        ref={anchorRef}
        className="new-unit-menu"
        aria-controls={open ? "menu-list-grow" : undefined}
        aria-haspopup="true"
        onClick={handleToggleMenu}
        title={<Translator id="addNewUnit" />}
        loading={loading}
        innerIcon={<Icons.FolderPlus />}
        size={"large"}
        variant="contained"
      />
      <Popper
        className="_toolbarMenu new-unit-buttons"
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow {...TransitionProps}>
            <Paper className="no-padding">
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList autoFocusItem={open} id="menu-list-grow">
                  <MenuItem onClick={() => onClick(2)}>
                    <ReactSVG src={Rectangle} />
                    <Translator id="addNewSquareUnit" />
                  </MenuItem>
                  <MenuItem onClick={() => onClick(1)}>
                    <ReactSVG src={NewUnit} />
                    <Translator id="addNewNoSquareUnit" />
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
}
